<template>
  <div class="mainContent">
    <div class="mainMask" :style="`opacity:${mainOpacity}`"></div>
    <!-- <img src="@/assets/images/YuliApp/main/title.png" class="title" alt="" /> -->
    <div class="subTitle">
      <div class="subTitle-first">Let's Make Friends and Earn</div>
      <div class="subTitle-second">
        A Revolutionary Urban Social AR MMORPG in Metaverse
      </div>
    </div>
    <div class="mainLink">
      <!-- <div class="mainLink-left" @click="toJump('whitePaper')">
        <div class="mainLink-left-button1">Whitepaper</div>
        <div class="mainLink-left-button2">Whitepaper</div>
      </div> -->
      <!-- <div class="mainLink-right" @click="toJump('getYuli')">
        <div class="mainLink-right-button1">Get Yuli NFT</div>
        <div class="mainLink-right-button2">Get Yuli NFT</div>
      </div> -->
    </div>
    <!-- <div class="footLink">
      <div class="footLink-left">Smart Contract</div>
      <div class="footLink-right">How to buy Tokens</div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    mainOpacity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  setup() {
    const toJump = (str) => {
      str === "whitePaper"
        ? window.open(
            "https://metaport.gitbook.io/the-white-paper-of-yuliverse/"
          )
        : window.open("https://presale.yuliverse.com");
    };
    return {
      toJump,
    };
  },
};
</script>

<style lang="less" scoped>
.mainContent {
  .mainMask {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    pointer-events: none;
  }
  display: flex;
  flex-direction: column;
  min-height: 900px;
  align-items: center;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 256px;
  color: #fff;
  width: 100%;
  text-align: center;
  height: calc(100vh - 80px);
  .title {
    width: 630px;
    height: 85px;
  }
  .subTitle {
    margin-top: 32px;
    &-first {
      width: 789px;
      height: 60px;
      font-size: 50px;
      font-weight: 400;
      font-family: "Josefin Sans";
    }
    &-second {
      width: 790px;
      height: 40px;
      font-size: 25px;
      font-weight: 400;
      font-family: "Josefin Sans";
    }
  }
  .mainLink {
    width: 392px;
    margin-top: 31px;
    display: flex;
    justify-content: space-between;
    &-left,
    &-right {
      cursor: pointer;
    }
    &-left {
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      transition: 0.7s;
      width: 200px;
      height: 54px;
      margin-right: 20px;
      padding: 0 0 13px 32px;
      border-radius: 61px;
      border: 1px solid rgba(0, 0, 0, 1);
      background-color: rgba(32, 32, 61, 0.8);
      &-button2 {
        box-sizing: border-box;
        width: 200px;
        height: 54px;
        padding: 14px 0 13px 14px;
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(0, 0);
        transition: 0.5s ease-out;

        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        font-family: "Josefin Sans";
        font-weight: 700;
        line-height: 30px;
        background: url("~@/assets/images/YuliApp/main/icon_whitepappers.svg")
          no-repeat 20px 15px;
        background-size: 24px;
      }
      &-button1 {
        box-sizing: border-box;
        width: 200px;
        height: 54px;
        padding: 14px 0 13px 14px;
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-100%, 0);
        transition: 0.5s ease-out;

        background: url("~@/assets/images/YuliApp/main/icon_whitepappers_black.svg")
          no-repeat 20px 15px;
        background-size: 24px;
        color: rgba(63, 59, 94, 1);
        font-size: 18px;
        font-weight: 700;
        font-family: "Josefin Sans";
        line-height: 30px;
      }
    }
    .mainLink-left:hover {
      background-color: #ecf0f1;
    }
    .mainLink-left:hover .mainLink-left-button1 {
      transform: translate(0, 0);
    }
    .mainLink-left:hover .mainLink-left-button2 {
      transform: translate(100%, 0);
    }
    &-right {
      position: relative;
      box-sizing: border-box;
      width: 200px;
      height: 54px;
      padding: 0 0 13px 14px;
      border-radius: 63px;
      border: 1px solid rgba(0, 0, 0, 1);
      background-color: rgba(62, 46, 129, 1);
      overflow: hidden;
      transition: 0.7s;
      &-button2 {
        box-sizing: border-box;
        width: 200px;
        height: 54px;
        padding: 14px 0 13px 14px;
        background: url("~@/assets/images/YuliApp/main/icon_getYuli.svg")
          no-repeat 20px 15px;
        background-size: 24px;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        font-family: "Josefin Sans";
        font-weight: 900;
        text-align: center;
        line-height: 30px;

        position: absolute;
        left: 0;
        top: 0;
        transform: translate(0, 0);
        transition: 0.5s ease-out;
      }
      &-button1 {
        box-sizing: border-box;
        width: 200px;
        height: 54px;
        padding: 14px 0 13px 14px;
        background: url("~@/assets/images/YuliApp/main/icon_getYuli_black.svg")
          no-repeat 18px 15px;
        background-size: 24px;
        color: rgba(63, 59, 94, 1);
        font-size: 18px;
        font-weight: 900;
        font-family: "Josefin Sans";
        text-align: center;
        line-height: 30px;

        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-100%, 0);
        transition: 0.5s ease-out;
      }
    }
    .mainLink-right:hover {
      background-color: rgba(255, 255, 255, 1);
    }
    .mainLink-right:hover .mainLink-right-button1 {
      transform: translate(0, 0);
    }
    .mainLink-right:hover .mainLink-right-button2 {
      transform: translate(100%, 0);
    }
  }
  .footLink {
    width: 392px;
    position: absolute;
    bottom: 300px;
    font-size: 16.32px;
    font-weight: 900;
    display: flex;
    justify-content: space-between;
    &-left {
      width: 192px;
      height: 54px;
      border-radius: 42px;
      opacity: 1;
      border: 1px solid rgba(0, 0, 0, 0.5);
      background: rgba(32, 32, 61, 0.5);
      margin-right: 8px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
      text-align: center;
      &:hover {
        color: rgba(63, 59, 94, 1);
        border: 1px solid rgba(0, 0, 0, 1);
        background: rgba(255, 255, 255, 0.5);
      }
    }
    &-right {
      width: 192px;
      height: 54px;
      border-radius: 42px;
      opacity: 1;
      border: 1px solid rgba(0, 0, 0, 0.5);
      background: rgba(32, 32, 61, 0.5);
      margin-right: 8px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
      text-align: center;
      &:hover {
        color: rgba(63, 59, 94, 1);
        border: 1px solid rgba(0, 0, 0, 1);
        background: rgba(255, 255, 255, 0.5);
      }
    }
    &-left,
    &-right {
      width: 192px;
      cursor: pointer;
      height: 54px;
    }
  }
}
</style>
